// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-default {
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 11;
  height: 100%;
  position: fixed;
}
.modal-default .close-page {
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-default .btn-close {
  border: 0;
  top: 15px;
  padding: 0;
  right: 15px;
  position: absolute;
}
.modal-default .btn-close img {
  width: 20px;
  height: 20px;
}
.modal-default .wrapper-modal {
  bottom: 0;
  z-index: 2;
  width: 100%;
  padding: 16px;
  overflow: auto;
  max-height: 90vh;
  position: absolute;
  border-radius: 4px;
  border: 2px solid var(--sebrae-light-blue3);
  background-color: var(--sebrae-white);
  box-shadow: 0 1px 30px 6px rgba(20, 46, 82, 0.2);
}
.modal-default .wrapper-modal.square {
  border-radius: 0;
}
.modal-default .modal-header {
  border-bottom: 1px solid var(--sebrae-light-gray4);
  margin: 0 -16px;
  padding: 0 16px;
  margin-bottom: 16px;
}
.modal-default .title {
  color: var(--sebrae-gray);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 23.3px;
  padding-bottom: 15px;
}
@media screen and (min-width: 768px) {
  .modal-default {
    height: 100%;
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  }
  .modal-default .btn-close {
    display: block;
  }
  .modal-default .wrapper-modal {
    overflow: auto;
    width: 100%;
    height: auto;
    max-width: 553px;
    position: relative;
    padding: 15px 16px;
    background-color: var(--sebrae-white);
    box-shadow: 0 1px 30px 0 rgba(20, 46, 82, 0.2);
  }
  .modal-default .wrapper-modal.square {
    border-radius: 0;
  }
}
@media screen and (min-width: 768px) {
  .modal-default .title {
    font-size: 23px;
  }
}

.modal-alert-mobile .wrapper-modal {
  overflow: auto;
  width: 100%;
  height: auto;
  max-width: 343px;
  position: relative;
  padding: 15px 16px;
  background-color: var(--sebrae-white);
  box-shadow: 0 1px 30px 0 rgba(20, 46, 82, 0.2);
}
.modal-alert-mobile .wrapper-modal .modal-body {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.modal-alert-mobile .wrapper-modal .modal-body .text-modal-alert {
  font-size: 11px;
  font-weight: 400;
  font-family: Figtree;
}
.modal-alert-mobile .wrapper-modal .modal-body .text-modal-alert b {
  font-weight: bold;
}
.modal-alert-mobile .wrapper-modal .modal-body .wrapper-btn-modal-alert {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.modal-alert-mobile .wrapper-modal .modal-body .wrapper-btn-modal-alert .btn-modal-alert {
  background-color: var(--sebrae-blue-6);
  font-size: 13px;
  font-weight: 400;
  font-family: Figtree;
  color: var(--sebrae-white);
  padding: 8px 12px;
  border-radius: 4px;
}
@media (min-width: 375px) {
  .modal-alert-mobile .wrapper-modal {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .modal-alert-mobile .wrapper-modal .modal-body .text-modal-alert {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/modal-default/index.scss"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AACF;AACE;EACE,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;AACJ;AAEE;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;AAAN;AAIE;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2CAAA;EACA,qCAAA;EACA,gDAAA;AAFJ;AAII;EACE,gBAAA;AAFN;AAME;EACE,kDAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAJJ;AAOE;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AALJ;AAQE;EAjEF;IAkEI,YAAA;IACA,aAAA;IACA,eAAA;IACA,mBAAA;IACA,uBAAA;IACA,6BAAA;EALF;EAOE;IACE,cAAA;EALJ;EAQE;IACE,cAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,kBAAA;IACA,qCAAA;IACA,8CAAA;EANJ;EAQI;IACE,gBAAA;EANN;AACF;AAUE;EACE;IACE,eAAA;EARJ;AACF;;AAaE;EAIE,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,8CAAA;AAbJ;AAeI;EAEE,aAAA;EACA,sBAAA;EACA,SAAA;AAdN;AAgBM;EAEI,eAAA;EACA,gBAAA;EACA,oBAAA;AAfV;AAkBQ;EACE,iBAAA;AAhBV;AAoBM;EACI,WAAA;EACA,aAAA;EACA,yBAAA;AAlBV;AAmBU;EACE,sCAAA;EAGE,eAAA;EACA,gBAAA;EACA,oBAAA;EAGF,0BAAA;EACA,iBAAA;EACA,kBAAA;AArBZ;AA6BE;EACE;IACE,QAAA;IACA,SAAA;IACA,gCAAA;EA3BJ;EA8BM;IACI,eAAA;EA5BV;AACF","sourcesContent":[".modal-default {\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  z-index: 11;\n  height: 100%;\n  position: fixed;\n\n  .close-page {\n    top: 0;\n    left: 0;\n    z-index: 1;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n\n  .btn-close {\n    border: 0;\n    top: 15px;\n    padding: 0;\n    right: 15px;\n    position: absolute;\n\n    img {\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .wrapper-modal {\n    bottom: 0;\n    z-index: 2;\n    width: 100%;\n    padding: 16px;\n    overflow: auto;\n    max-height: 90vh;\n    position: absolute;\n    border-radius: 4px;\n    border: 2px solid var(--sebrae-light-blue3);\n    background-color: var(--sebrae-white);\n    box-shadow: 0 1px 30px 6px rgba(20, 46, 82, 0.2);\n\n    &.square {\n      border-radius: 0;\n    }\n  }\n\n  .modal-header {\n    border-bottom: 1px solid var(--sebrae-light-gray4);\n    margin: 0 -16px;\n    padding: 0 16px;\n    margin-bottom: 16px;\n  }\n\n  .title {\n    color: var(--sebrae-gray);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 23.3px;\n    padding-bottom: 15px;\n  }\n\n  @media screen and (min-width: 768px) {\n    height: 100%;\n    display: flex;\n    position: fixed;\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n\n    .btn-close {\n      display: block;\n    }\n\n    .wrapper-modal {\n      overflow: auto;\n      width: 100%;\n      height: auto;\n      max-width: 553px;\n      position: relative;\n      padding: 15px 16px;\n      background-color: var(--sebrae-white);\n      box-shadow: 0 1px 30px 0 rgba(20, 46, 82, 0.2);\n\n      &.square {\n        border-radius: 0;\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    .title {\n      font-size: 23px;\n    }\n  }\n}\n\n.modal-alert-mobile {\n  .wrapper-modal {\n    // top: 50%;\n    // left: 50%;\n    // transform: translate(-50%,-50%);\n    overflow: auto;\n    width: 100%;\n    height: auto;\n    max-width: 343px;\n    position: relative;\n    padding: 15px 16px;\n    background-color: var(--sebrae-white);\n    box-shadow: 0 1px 30px 0 rgba(20, 46, 82, 0.2);\n\n    .modal-body {\n\n      display: flex;\n      flex-direction: column;\n      gap: 32px;\n\n      .text-modal-alert {\n        font: {\n          size: 11px;\n          weight: 400;\n          family: Figtree;\n        }\n\n        b{\n          font-weight: bold;\n        }\n      }\n\n      .wrapper-btn-modal-alert{\n          width: 100%;\n          display: flex;\n          justify-content: flex-end;\n          .btn-modal-alert {\n            background-color: var(--sebrae-blue-6);\n    \n            font: {\n              size: 13px;\n              weight: 400;\n              family: Figtree;\n            }\n    \n            color: var(--sebrae-white);\n            padding: 8px 12px;\n            border-radius: 4px;\n          }\n      }\n\n    }\n\n  }\n\n  @media(min-width: 375px) {\n    .wrapper-modal {\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n\n      .modal-body{\n        .text-modal-alert{\n            font-size: 12px;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
